import React from "react";

export default function VouchCard({ vouch, idx }) {
  const avatarUrl = vouch.avatar || null;
  function getInitials(name) {
    if (!name) return "👤";
    const parts = name.split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  const userIdLink = vouch.userid
    ? `https://discord.com/users/${vouch.userid}`
    : null;

  // Discord-Icon rechts oben
  const discordIcon = (
    <span
      style={{
        position: "absolute",
        top: "1.2rem",
        right: "1.2rem",
        color: "#5865F2",
        fontSize: "1.35rem"
      }}
      title="Discord"
    >
      <span role="img" aria-label="Discord">🟦</span>
    </span>
  );

  function formatMessage(msg) {
    if (!msg) return "";
    return msg.replace(/(<@[\d]+>)/g, (m) => (
      `<b style="color:#FF0000">${m}</b>`
    ));
  }

  return (
    <div
      className="vouch-card"
      style={{
        background: "#222226",
        borderRadius: "0.25rem",
        border: "1.5px solid #23232a",
        padding: "1.3rem 2rem 1.3rem 2rem",
        minHeight: "110px",
        maxWidth: "480px",
        margin: "0",
        display: "flex",
        flexDirection: "column",
        position: "relative"
      }}
    >
      {/* Avatar, Username, User-ID, Discord-Icon */}
      <div style={{ display: "flex", alignItems: "center", gap: "1.1rem", marginBottom: "0.7rem" }}>
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt="avatar"
            style={{
              width: "2.4rem",
              height: "2.4rem",
              borderRadius: "0.25rem",
              objectFit: "cover",
              background: "#19191b"
            }}
          />
        ) : (
          <div
            style={{
              width: "2.4rem",
              height: "2.4rem",
              borderRadius: "0.25rem",
              background: "#19191b",
              color: "#FF0000",
              fontWeight: "bold",
              fontSize: "1.1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1.5px solid #23232a"
            }}
          >
            {getInitials(vouch.name)}
          </div>
        )}
        <span style={{ fontWeight: "bold", color: "#FF0000", fontSize: "1.08rem" }}>
          @{vouch.name}
        </span>
        {userIdLink && (
          <a
            href={userIdLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#eaeaea",
              fontSize: "0.97rem",
              textDecoration: "underline",
              fontWeight: "bold"
            }}
          >
            ({vouch.userid})
          </a>
        )}
        {discordIcon}
      </div>
      {/* Sterne */}
      <div style={{
        color: "#FF0000",
        fontSize: "1.1rem",
        fontWeight: "bold",
        marginBottom: "0.5rem"
      }}>
        {"★".repeat(vouch.rating)}
      </div>
      {/* Nachricht */}
      <div
        style={{
          color: "#fff",
          fontSize: "1.08rem",
          marginBottom: "0.7rem",
          fontWeight: 500
        }}
        dangerouslySetInnerHTML={{
          __html: formatMessage(vouch.message)
        }}
      />
      {/* Meta */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#bdbdbd",
        fontSize: "0.97rem",
        marginTop: "1.2rem"
      }}>
        <span>Vouch N°{idx}</span>
        <span>{vouch.date}</span>
      </div>
    </div>
  );
}
